import { useRef } from 'react';

import { v4 } from 'uuid';

import { useAppContext } from 'hooks/context/useAppContext';

import { defaultGradient } from 'utils/gradientUtils';

type Props = {
  className?: string;
  height?: number;
  width?: number;
  render: (id: string) => JSX.Element;
};

export const GradientPath = ({
  className,
  render,
  height = 34,
  width = 34,
}: Props) => {
  const { publicUser } = useAppContext();

  const brandPrimaryColor =
    publicUser?.preferences.brand_color_override_primary ||
    publicUser?.organization_gradient ||
    defaultGradient;

  const [startGradient, endGradient] = brandPrimaryColor.colors;

  const viewBox = `-0.5 -0.5 ${width} ${height}`;
  const id = useRef(`gradient-${v4().toString()}`);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={viewBox}
      className={className}
    >
      <defs>
        <linearGradient id={id.current} x1="0%" y1="0%" x2="0%" y2="100%">
          {startGradient && <stop offset="0%" stopColor={startGradient} />}
          {endGradient && <stop offset="100%" stopColor={endGradient} />}
        </linearGradient>
      </defs>
      {render(id.current)}
    </svg>
  );
};
